import { StyleSheet, Text, View } from "react-native";
import { FontAwesome as Icon } from "@expo/vector-icons";
import React from "react";
// import shallowEqual from "react-apollo/utils/shallowEqual";
import {
  CustomPaginatedSelect,
  CustomSelect,
  ImageAlbum,
  TextInput,
} from "./index";
import {
  THEME_COLORS,
  OTHER_CONSTANTS,
  commonStyles,
  FONT_SIZE,
} from "../styles";
import { GetApprovalVerificationStatus } from "./ApprovalVerificationStatus";
import { isIntegerNumber, isFloatingNumber, toTwoDecimalNo } from "../helper";
import { GetPaginatedCarPartList } from "../../screen/CreateInvoice/container/GetPaginatedCarPartList";

interface IMicroJobRowProps {
  mjrData: any;
  isMicroJobRowEditable?: boolean;
  isRemoveButtonVisible?: boolean;
  isAddButtonVisible?: boolean;
  isAddRemoveButtonViewVisible?: boolean;
  onRemoveButtonClick?: () => void;
  onAddButtonClick?: () => void;
  onMJRDataChange?: (object) => void;
  microParts?: object[];
  taxCodes?: object[];
  fix?: object[];
  bgColor?: string;
  showImageAlbumButton?: boolean;
  isApproveVerifyColumnVisible?: boolean;
}

const MicroJobRow = (props: IMicroJobRowProps) => {
  const microCarPartList = !!props.microParts ? props.microParts : [];
  const taxCodeList = !!props.taxCodes ? props.taxCodes : [];
  const hsnCodes = taxCodeList.filter((tx) => tx.type === "HSN");
  const sacCodes = taxCodeList.filter((tx) => tx.type === "SAC");
  const mjrData = props.mjrData;
  const microPartId = mjrData.part ? mjrData.part.id : null;
  const images = mjrData.images;
  const brandName = mjrData.brand;
  const partCost = mjrData.partCost;
  const partCount = mjrData.partCount;
  const labourCost = mjrData.labourCost;
  const isHsnRequired = partCost && Number(partCost) > 0;
  const isSacRequired = labourCost && Number(labourCost) > 0;
  const totalPartCost =
    partCost !== "" && partCount !== ""
      ? Number(toTwoDecimalNo(Number(partCost) * Number(partCount)))
      : 0;
  const totalLabourCost =
    labourCost !== "" ? Number(toTwoDecimalNo(Number(labourCost))) : 0;
  const totalCost = toTwoDecimalNo(totalLabourCost + totalPartCost);
  const isAddButtonVisible = props.isAddButtonVisible;
  const isAddRemoveButtonViewVisible = props.isAddRemoveButtonViewVisible;
  const isRemoveButtonVisible = props.isRemoveButtonVisible;
  const isMicroJobRowFieldsDisabled = !props.isMicroJobRowEditable;
  const onRemoveButtonClickCallback = props.onRemoveButtonClick;
  const onAddNewMicroJobRowCallback = props.onAddButtonClick;
  const onMJRDataChange = props.onMJRDataChange;
  const isApproveVerifyColumnVisible = props.isApproveVerifyColumnVisible;
  const showImageAlbumButton =
    !!props.showImageAlbumButton && props.showImageAlbumButton;
  const microFixList = !!props.fix ? props.fix : [];
  return (
    <View
      style={[
        styles.card,
        styles.row,
        !!props.bgColor ? { backgroundColor: props.bgColor } : null,
      ]}
    >
      <View style={[styles.columnPadding, styles.selectField]}>
        <GetPaginatedCarPartList>
          {(partList, loading, error, fetchMore, refetch) => (
            <CustomPaginatedSelect
              labelField={"name"}
              valueField={"id"}
              fieldName={"Part"}
              isRequired={true}
              disabled={isMicroJobRowFieldsDisabled}
              values={mjrData.part ? [mjrData.part] : []}
              options={partList?.data}
              onChange={(value) => {
                onMJRDataChange({
                  part: {
                    id: value[0].id,
                    name: value[0].name,
                  },
                });
              }}
              extraDataFrom={"getCarPartsPaginated"}
              loading={loading}
              error={error}
              pagingInfo={partList?.paginator}
              fetchMore={fetchMore}
              refetch={refetch}
            />
          )}
        </GetPaginatedCarPartList>
        {showImageAlbumButton && !!images ? (
          <ImageAlbum
            images={images.map((img) => {
              return {
                ...img,
                label: `${!!mjrData.part ? mjrData.part.name + " - " : ""}${img.label}`,
              };
            })}
          />
        ) : null}
      </View>
      <View style={[styles.columnPadding, styles.selectField]}>
        <CustomSelect
          labelField={"name"}
          valueField={"id"}
          disabled={isMicroJobRowFieldsDisabled}
          searchBy={"name"}
          values={mjrData.fix ? [mjrData.fix] : []}
          options={microFixList}
          isRequired={true}
          fieldName={"Fix"}
          onChange={(value) => {
            onMJRDataChange({ fix: { id: value[0].id, name: value[0].name } });
          }}
        />
      </View>
      <View style={[styles.columnPadding, styles.justifyContentCenter]}>
        <Text style={[styles.labelText, styles.inputMargins]}>
          Micro Part:{" "}
        </Text>
        <Text style={[styles.labelText, styles.inputMargins]}>Service: </Text>
      </View>
      <View style={styles.columnPadding}>
        <TextInput
          style={[
            styles.inputMargins,
            commonStyles.input,
            isMicroJobRowFieldsDisabled ? commonStyles.disabledInput : null,
          ]}
          placeholder={"Brand"}
          value={brandName}
          onChangeText={(text) => {
            text.length < 20 ? onMJRDataChange({ brand: text }) : null;
          }}
          disabled={isMicroJobRowFieldsDisabled}
        />
      </View>
      <View style={[styles.columnPadding]}>
        <TextInput
          style={[
            styles.inputMargins,
            commonStyles.input,
            isMicroJobRowFieldsDisabled ? commonStyles.disabledInput : null,
          ]}
          value={partCost.toString()}
          onChangeText={(text) => {
            isIntegerNumber(text) || text === ""
              ? onMJRDataChange({ partCost: text })
              : null;
          }}
          disabled={isMicroJobRowFieldsDisabled}
        />
        <TextInput
          style={[
            styles.inputMargins,
            commonStyles.input,
            isMicroJobRowFieldsDisabled ? commonStyles.disabledInput : null,
          ]}
          value={labourCost.toString()}
          onChangeText={(text) => {
            isIntegerNumber(text) || text === ""
              ? onMJRDataChange({ labourCost: text })
              : null;
          }}
          disabled={isMicroJobRowFieldsDisabled}
        />
      </View>
      <View style={[styles.columnPadding]}>
        <TextInput
          style={[
            styles.inputMargins,
            commonStyles.input,
            isMicroJobRowFieldsDisabled ? commonStyles.disabledInput : null,
          ]}
          value={partCount.toString()}
          onChangeText={(text) => {
            isFloatingNumber(text) || text === ""
              ? onMJRDataChange({ partCount: toTwoDecimalNo(text) })
              : null;
          }}
          disabled={isMicroJobRowFieldsDisabled}
        />
      </View>
      <View
        style={[
          styles.columnPadding,
          styles.justifyContentCenter,
          styles.selectField,
        ]}
      >
        <CustomSelect
          labelField={"code"}
          valueField={"id"}
          disabled={isMicroJobRowFieldsDisabled}
          searchBy={"code"}
          values={mjrData.hsn ? [mjrData.hsn] : []}
          options={hsnCodes}
          isRequired={isHsnRequired}
          fieldName={"HSN"}
          onChange={(value) => {
            onMJRDataChange({ hsn: { id: value[0].id, code: value[0].code } });
          }}
        />
        <CustomSelect
          labelField={"code"}
          valueField={"id"}
          disabled={isMicroJobRowFieldsDisabled}
          searchBy={"code"}
          fieldName={"SAC"}
          isRequired={isSacRequired}
          values={mjrData.sac ? [mjrData.sac] : []}
          options={sacCodes}
          onChange={(value) => {
            onMJRDataChange({ sac: { id: value[0].id, code: value[0].code } });
          }}
        />
        {/*<TextInput*/}
        {/*style={[styles.inputWidthHeight, styles.input]}*/}
        {/*// onChangeText={(text) => this.setState({text})}*/}
        {/*// value={this.state.text}*/}
        {/*/>*/}
      </View>
      <View style={[styles.columnPadding, styles.justifyContentCenter]}>
        <TextInput
          style={[
            styles.inputMargins,
            commonStyles.input,
            commonStyles.disabledInput,
          ]}
          value={totalPartCost.toString()}
          disabled
        />
        <TextInput
          style={[
            styles.inputMargins,
            commonStyles.input,
            commonStyles.disabledInput,
          ]}
          value={totalLabourCost.toString()}
          disabled
        />
      </View>
      <View style={[styles.columnPadding, styles.justifyContentCenter]}>
        <TextInput
          style={[
            styles.inputMargins,
            commonStyles.input,
            commonStyles.disabledInput,
          ]}
          value={totalCost.toString()}
          disabled
        />
      </View>
      {isApproveVerifyColumnVisible ? (
        <GetApprovalVerificationStatus
          approvalStatus={mjrData.approvalStatus}
          verification={mjrData.verification}
        />
      ) : null}
      {isAddRemoveButtonViewVisible ? (
        <View
          style={[styles.columnPadding, styles.row, styles.addRemoveColumn]}
        >
          <View style={{ flex: 1, flexDirection: "row" }}>
            {isAddButtonVisible ? (
              <Icon
                style={styles.cursorPointer}
                name="plus-circle"
                color="#13B54B"
                size={24}
                onPress={() => {
                  onAddNewMicroJobRowCallback();
                  // this.addNewMicroJobRow(jobRowAssignedIndex);
                }}
              />
            ) : null}
          </View>
          <View style={{ flex: 1, flexDirection: "row" }}>
            {isRemoveButtonVisible ? (
              <Icon
                style={styles.cursorPointer}
                name="times-circle"
                color="#FF0037"
                size={24}
                onPress={() => {
                  onRemoveButtonClickCallback();
                }}
              />
            ) : null}
          </View>
        </View>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    justifyContent: "space-between",
    borderBottomWidth: 1,
    borderBottomColor: THEME_COLORS.border2,
    minHeight: 150,
    zIndex: "auto",
  },
  row: {
    flex: 1,
    flexDirection: "row",
  },
  labelText: {
    color: "#200E36",
    fontWeight: "bold",
    fontFamily: "Roboto",
    fontSize: FONT_SIZE.s2,
    height: OTHER_CONSTANTS.inputHeight,
  },
  justifyContentCenter: {
    justifyContent: "center",
  },
  columnPadding: {
    padding: 5,
    flex: 1,
  },
  inputMargins: {
    marginTop: 5,
    marginBottom: 5,
  },
  addRemoveColumn: {
    alignItems: "center",
    justifyContent: "space-around",
  },
  cursorPointer: {
    cursor: "pointer",
  },
  selectField: {
    zIndex: "auto",
  },
});
const getCompareObject = (props: IMicroJobRowProps) => {
  return {
    isAddButtonVisible: props.isAddButtonVisible,
    isRemoveButtonVisible: props.isRemoveButtonVisible,
    isAddRemoveButtonViewVisible: props.isAddRemoveButtonViewVisible,
    isMicroJobRowEditable: props.isMicroJobRowEditable,
    ...props.mjrData,
  };
};
const areEqual = (
  nextProps: IMicroJobRowProps,
  prevProps: IMicroJobRowProps
) => {
  return (
    JSON.stringify(getCompareObject(nextProps)) ===
    JSON.stringify(getCompareObject(prevProps))
  );
};
export default React.memo(MicroJobRow, areEqual);
